import React from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
let globalExecutors = [];
const listeners = new Set();
export function registerGlobalExecutor(executor) {
    globalExecutors = [...globalExecutors, executor];
    listeners.forEach(listener => listener());
}
export const HoxRoot = props => {
    const executors = useSyncExternalStore(onStoreChange => {
        listeners.add(onStoreChange);
        return () => {
            listeners.delete(onStoreChange);
        };
    }, () => {
        return globalExecutors;
    });
    return (React.createElement(React.Fragment, null,
        executors.map((Executor, index) => (React.createElement(Executor, { key: index }))),
        props.children));
};
